import React, { useState, useEffect } from "react";
import { string, number, oneOfType, object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import DefaultMobileLogo from "../../../../atoms/icons/default-mobile-logo";
import FooterLogo from "./FooterLogo";
import { getCurrentSite } from "../../../../utils/utils";

const DefaultFooterLogo = ({ publisherAttributes, currentPath }) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    global.deviceWidth > 876 && setIsDesktop(!isDesktop);
  }, []);

  const width = isDesktop ? "200" : "180";
  const height = isDesktop ? "27" : "24.3";

  const renderLogo = () => {
    if (publisherAttributes.lang === "en" || getCurrentSite(currentPath) === "en") {
      return <FooterLogo width={width} height={height} />;
    } else {
      return <DefaultMobileLogo width={width} height={height} />;
    }
  };

  return <div>{renderLogo()}</div>;
};

const mapStateToProps = state => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null)
});

DefaultFooterLogo.propTypes = {
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  publisherAttributes: object,
  currentPath: string
};

export default connect(mapStateToProps, null)(DefaultFooterLogo);
